import { useEffect, useState, createContext } from "react";
import { auth } from "../util/firebase";
import { onAuthStateChanged } from "firebase/auth";
import Loading from "../particles/Loading";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user.uid);
        setPending(false);
      } else {
        setCurrentUser(null);
        setPending(false);
      }
    });
  }, []);

  if (pending) {
    return (
      <>
        <Loading/>
      </>
      );
  }

  return (
    <AuthContext.Provider value={{ currentUser }}>
      {children}
    </AuthContext.Provider>
  );
};
